import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { useCreateCardMutation } from "../../../features/card/cardApi";
import { toast } from "react-toastify";

interface SaveCardFormProps {
  onClose: () => void;
}

const SaveCardForm: React.FC<SaveCardFormProps> = ({ onClose }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const [createCard] = useCreateCardMutation();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    const result = await stripe.confirmSetup({
      elements,
      confirmParams: {},
      redirect: "if_required",
    });

    if (!result.error) {
      const paymentMethodId = result.setupIntent?.payment_method;
      await createCard({ token: paymentMethodId });
      onClose();
    }
    else {
      toast.error(result?.error?.message);
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="rounded-lg space-y-6">
      <PaymentElement
        options={{
          layout: "auto",
        }}
      />
      <button
        type="submit"
        disabled={!stripe || loading}
        className="mt-3 btn btn-primary w-full py-2 transition duration-200"
      >
        {loading ? "Saving..." : "Save Card"}
      </button>
    </form>
  );
};

export default SaveCardForm;
